<template>
  <div @click="$emit('onClick')" :title="title" :style="'width:' + width" :class="{'text-center': center}">
    <ks-popover
        v-if="popoverValue"
        :hoverText="popoverValue"
        :showAsHtml="htmlPopover"
        :value="text"
    />
    <h1 v-else-if="tag === 'h1'" :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles">{{ text }}</h1>
    <h2 v-else-if="tag === 'h2'" :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles">{{ text }}</h2>
    <h3 v-else-if="tag === 'h3'" :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles">{{ text }}</h3>
    <h4 v-else-if="tag === 'h4'" :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles">{{ text }}</h4>
    <h5 v-else-if="tag === 'h5'" :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles">{{ text }}</h5>
    <p v-else-if="tag === 'p'" :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles">{{ text }}</p>
    <a v-else-if="tag === 'a'" :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles" :href="href">{{ text }}</a>
    <strong v-else-if="tag === 'strong'" :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles">{{ text }}</strong>
    <span v-else-if="tag === 'currency'" :class="classes" :style="styles + (floatCurrencyRight ? ' float: right;' : '')">
      {{ formatCurrency(text) }}
    </span>
    <span v-else :class="classes + (ellipsis ? ' ellipsis' : '')" :style="styles">{{ text }}</span>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: "ks-text",
  mixins: [checkPermissions],
  props: {
    text: {
      type: [String, Number],
      required: false,
      default: ''
    },
    popoverValue: {
      type: String,
      default: null
    },
    htmlPopover: {
      type: Boolean,
      default: false
    },
    classes: {
      type: String,
      required: false
    },
    styles: {
      type: String,
      required: false
    },
    tag: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    ellipsis: {
      type: Boolean,
      default: true
    },
    center: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: null
    },
    floatCurrencyRight: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    formatCurrency(amount) {
      return app.formatCurrency(amount)
    }
  }
}
</script>
<style scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
